<button (click)="onClick($event)" [attr.aria-label]="label" [class]="cssClass " [color]="color" [disabled]="disabled" [type]="type"
        mat-raised-button>
  <mat-icon *ngIf="icon" aria-hidden="true" class="mr-1">{{icon}}</mat-icon>
  <span *ngIf="breakLabel" class="breaking-text">{{label}}</span>
  <span *ngIf="!breakLabel">{{label}}</span>
</button>
